import {
  CONTENT_FULFILLED,
  FETCH_ICONIC_STORIES_TYPE,
  ICONIC_STORIES_FILTER_CHANGED,
} from '../actions';
import createFetchReducer, { createItemSetsFromSlicesGetter } from './createFetchReducer';
import mergeSliceState from '../helpers/mergeSliceState';
import get from '../helpers/get';
import transformLinkProperties from '../server/CMS/transformLinkProperties';

const initialState = {};

const keyFiltersById = ({ items }, mapFilterItem) => items.reduce((itemsById, filterItem) => {
  const filterId = Number(filterItem.stackla_filter_id);
  return {
    ...itemsById,
    ...(filterId ? { [filterId]: mapFilterItem(filterItem, filterId) } : undefined),
  };
}, {});

const fetchReducer = createFetchReducer({
  initialState,
  actionType: FETCH_ICONIC_STORIES_TYPE,
  // Stackla filters are the relevant unit of "state slice" for THE ICONIC stories (whereas for
  // other components, it is the Prismic slice)
  itemSetIdName: 'filterId',
  itemSetNamePlural: 'filters',
  itemTypePlural: 'tiles',
  itemIdName: 'id',
  getItemSetsFromSlices: createItemSetsFromSlicesGetter({
    getItemSetsFromSliceContent: sliceContent => {
      if (sliceContent.type === 'iconic_stories') {
        return keyFiltersById(sliceContent, () => ({}));
      }
      return undefined;
    },
    itemSetNamePlural: 'filters',
  }),
});

// as well as storing sets of tiles per filter, we still need to store state per Prismic slice
// under the `slices` key - which Stackla filters are available, and which filter is currently
// selected, in each slice
const initializeSlices = createItemSetsFromSlicesGetter({
  getItemSetsFromSliceContent: sliceContent => {
    if (sliceContent.type === 'iconic_stories') {
      let firstFilterId;
      const filters = keyFiltersById(
        sliceContent,
        (itemContent, filterId) => {
          if (!firstFilterId) {
            firstFilterId = filterId;
          }
          return {
            name: itemContent.stackla_filter_name,
            clickthrough: transformLinkProperties(itemContent, 'clickthrough'),
          };
        },
      );
      return {
        [sliceContent.sliceId]: {
          filters,
          filterId: firstFilterId,
        },
      };
    }
    return undefined;
  },
});

const handleFilterChanged = (prevState, sliceId, filterName) => {
  const filterInfoById = get(prevState, ['slices', sliceId, 'filters']) || {};
  const filterId = Number(Object.keys(filterInfoById).find(
    candidateFilterId => get(filterInfoById, [candidateFilterId, 'name']) === filterName,
  ));
  return {
    ...prevState,
    slices: mergeSliceState(prevState.slices, sliceId, { filterId: filterId || undefined }),
  };
};

export default (state = initialState, action) => {
  const nextState = fetchReducer(state, action);
  switch (action.type) {
    case CONTENT_FULFILLED:
      return {
        // nextState contains the `filters` state slice
        ...nextState,
        // and here we’ll merge in the `slices` state
        ...initializeSlices(state, action.payload),
      };
    case ICONIC_STORIES_FILTER_CHANGED:
      return handleFilterChanged(state, action.meta.sliceId, action.payload.filterName);
    default:
      return nextState;
  }
};
